module.exports = __webpack_public_path__ + "img/price-tag-3-line.bceb4ef2.svg";